import React from 'react';
import ArticleLayout from '../../components/HelpCenterComponents/ArticleLayout';
import { AlliancesContentBody } from '../../components/data/data/HelpCenter/Alliances';

// Define article configuration
const ARTICLE_TITLES = [
  'SpatialGrid Alliances',
  'Type of Alliances',
  'Alliances Objectives',
  'Benefits',
];

const TOC_DATA = {
  0: [
    'SpatialGrid Alliances', // This should match the heading in your content
  ],
  1: ['Type of Alliances'],
  2: ['Alliances Objectives'],
  3: ['Benefits'],
};

const AlliancesArticles = () => {
  return (
    <ArticleLayout
      articleTitles={ARTICLE_TITLES}
      tocData={TOC_DATA}
      ContentBodyComponent={AlliancesContentBody}
      sectionName="Alliances"
      searchPlaceholder="Search the Spatial Grid Help Center"
      showUseCases={true}
      showTitle={false}
    />
  );
};

export default AlliancesArticles;
